'use client'

import { ChangeEvent } from 'react'
import { useRouter, useTranslations } from '@/lib/next-shim'
import { UploadCloud } from 'react-feather'

type UploadButtonProps = {
  onFileUpload?: (file: File) => Promise<void>
  accept?: string
  disabled?: boolean
}

export function UploadButton({ onFileUpload, accept, disabled }: UploadButtonProps) {
  const router = useRouter()
  const t = useTranslations()

  const handleFileUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return

    if (onFileUpload) {
      await onFileUpload(file)
    } else {
      // Default behavior for backward compatibility
      console.log('called', event.target.files)
      // no choice but refresh page to revalidate fetch requests in server page component
      router.refresh()
    }
  }

  return (
    <div className="relative aspect-h-7 aspect-w-10">
      <input
        type="file"
        onChange={handleFileUpload}
        accept={accept}
        disabled={disabled}
        aria-label={t('accessibility.uploadFile')}
        className="absolute z-10 bg-transparent border-0 inset-0 opacity-0 w-full h-full cursor-pointer disabled:cursor-not-allowed"
      />
      <div
        className={`flex w-full overflow-hidden rounded-lg flex-row items-center justify-center border-2 border-dashed ${
          disabled ? 'border-gray-200 cursor-not-allowed' : 'border-gray-300 cursor-pointer hover:border-gray-400'
        } px-2 text-center focus-within:outline-none`}
      >
        <UploadCloud className={`mx-auto h-12 w-12 ${disabled ? 'text-gray-300' : 'text-gray-400'}`} />
      </div>
    </div>
  )
}
